import React from 'react';
import {
  FDBox,
  FDDisplayText, FDIcon, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import { PersonalizedOutcomeData } from './PersonalizedOutcomeData';
import { PersonalizedStrategyData } from './PersonalizedStrategyData';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary', align: 'center' },
  }, overrideReadOnly);

export const PersonalizedSectionLayout = ({ resource }) => {
  return (
    <FDStack direction={'column'} spacing={5} alignItems={'center'} paddingY={6} {...dataAttrs('goal-strategy-detail-personalized-section')}>
      <FDStack direction={'column'} spacing={1} alignItems={'center'}>
        {resource.attr('icon') ? <FDIcon icon={resource.attr('icon')} size={'md'} /> : null}
        <MetaControl resource={resource} attrName={'title'} metaOverrideSet={metaOverrides} />
      </FDStack>
      {resource.attr('personalizedOutcomeData')?.resources().list().map((po) => <PersonalizedOutcomeData key={po.id()} resource={po} />)}
      <FDBox /> {/* This is just being used as a spacing element because the designs require a ton of padding between these sections */}
      {resource.attr('personalizedStrategyData')?.resources().list().map((pd) => <PersonalizedStrategyData key={pd.id()} resource={pd} />)}
    </FDStack>
  );
};

PersonalizedSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
